import { gql } from '@apollo/client';

export default gql`
  mutation GenerateLeadListSignedURL($id: Int!, $fileName: String!, $listType: ListType!) {
    generateLeadListSignedURL(id: $id, fileName: $fileName, listType: $listType) {
      signedUrl
    }
  }
`;
